var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6352 8.93421C27.6939 8.03459 25.6264 7.37171 23.4483 6.99292C23.18 7.46641 22.8644 8.1135 22.6592 8.63434C20.3549 8.28712 18.0664 8.28712 15.8094 8.63434C15.5885 8.1135 15.2728 7.46641 15.0045 6.99292C12.8265 7.37171 10.7589 8.03459 8.81761 8.93421C4.90346 14.837 3.846 20.5978 4.36684 26.2638C6.97101 28.2051 9.48049 29.3731 11.9584 30.1464C12.5739 29.3099 13.1106 28.4103 13.584 27.4791C12.6844 27.1477 11.8321 26.7215 11.0272 26.2323C11.2482 26.0744 11.4534 25.9008 11.6585 25.743C16.5986 28.0473 21.949 28.0473 26.8259 25.743C27.0311 25.9166 27.2362 26.0744 27.4572 26.2323C26.6523 26.7215 25.7842 27.1319 24.9004 27.4791C25.3739 28.4103 25.9105 29.3099 26.526 30.1464C29.0039 29.3731 31.5292 28.2051 34.1176 26.2638C34.7331 19.6824 33.0601 13.9847 29.6668 8.93421H29.6352ZM14.2469 22.7916C12.7633 22.7916 11.548 21.4185 11.548 19.7297C11.548 18.0409 12.7318 16.6678 14.2469 16.6678C15.7621 16.6678 16.9616 18.0409 16.9458 19.7297C16.9458 21.4027 15.7621 22.7916 14.2469 22.7916ZM24.2059 22.7916C22.7223 22.7916 21.507 21.4185 21.507 19.7297C21.507 18.0409 22.6908 16.6678 24.2059 16.6678C25.7211 16.6678 26.9206 18.0409 26.9048 19.7297C26.9048 21.4027 25.7211 22.7916 24.2059 22.7916Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.7f061244a312eeed4c98011814916531.svg";
export { ForwardRef as ReactComponent };